// extracted by mini-css-extract-plugin
module.exports = {"head":"CustomDialog_head__ZpzS3","content":"CustomDialog_content__F8xW1","actions":"CustomDialog_actions__ylDIj"};